import React, { createElement, Fragment } from 'react';
import moduleCss from './index.module.scss';
import { Mask } from '@ifeng-fe/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng-fe/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng-fe/lowcode_tool/src/method/chip'
import Chip from 'Chip';
import { getThumbnailFromRecommend } from "@ifeng-fe/lowcode_tool/src/method/common";
import { formatImage } from '@ifeng-fe/public_method'

export interface NewsList_1_Props {
    nodeId?: string
    style?: object;
    newsChip: TYPE_Chip;
    hoverColor: string;

    itemStyle?: object

    titleStyle?: object

    subTitleGroupSize: number // 副标题每一组有几条
    subTitleStyle?: object

    isHasThumbnail: boolean // 是否需要缩略图
    thumbnailWidth: number
    thumbnailHeight: number
    thumbnailStyle?: object
}

const NewsList_1: React.FC<NewsList_1_Props> = (props) => {
    const { nodeId, newsChip, hoverColor, style,
        itemStyle,
        titleStyle,
        subTitleStyle, subTitleGroupSize,
        isHasThumbnail, thumbnailStyle, thumbnailWidth, thumbnailHeight
    } = props;

    const newsChipData = useChip(newsChip);
    const chipComponentData = formatChip(newsChip)

    return (
        <Chip {...chipComponentData}>
            <div id={nodeId} className={moduleCss.newsList} style={style}>
                {newsChipData.map((item, index) => {
                    return (
                        <div className={moduleCss.news} key={index} style={itemStyle}>
                            {
                                isHasThumbnail && <img src={formatImage(getThumbnailFromRecommend(item), thumbnailWidth, thumbnailHeight)} style={{ width: `${thumbnailWidth}px`, height: `${thumbnailHeight}px`, ...thumbnailStyle }} alt="" />
                            }
                            <div>
                                {/*@ts-ignore*/}
                                <div className={moduleCss.title} style={{ ...titleStyle, '--color-hover': hoverColor }}>
                                    <a href={item.url} target="_blank" rel="noreferrer">
                                        {item.title}
                                    </a>
                                </div>
                                <div>
                                    {item.children &&
                                        item.children
                                            .filter((a, i) => i % subTitleGroupSize === 0)
                                            .map((i, idx) => {

                                                return (
                                                    <p key={idx} style={{ ...subTitleStyle }}>
                                                        {
                                                            item.children.slice(subTitleGroupSize * idx, subTitleGroupSize * (idx + 1)).map((d, i) => {
                                                                return (
                                                                    <Fragment>
                                                                        {
                                                                            i !== 0 ? ' | ' : ''
                                                                        }
                                                                        <span style={{ '--color-hover': hoverColor }}>
                                                                            <a
                                                                                href={d.url}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                {d.title}
                                                                            </a>
                                                                        </span>
                                                                    </Fragment>
                                                                )
                                                            })
                                                        }
                                                    </p>
                                                );
                                            })}
                                </div>
                            </div>
                        </div>
                    );
                })}
                <Mask visible={!newsChip.id} zIndex={3}>示例推荐位碎片—{newsChip.default.id}</Mask>
            </div>
        </Chip>
    );
};

export default NewsList_1;
